export default __webpack_public_path__ + "static/media/recuadroCuatro.7db6dbfd.png";